import { Row as TableRow } from 'react-table';

import { Row } from '../Row';

const BodyView = ({
  rows,
  prepareRow,
  borderBottom,
  borderRight,
  alternating,
  onRowClick,
  tableBodyStyle,
  fullWidth,
  isRowDeleted,
  hasRowReordering,
  selectedReorderingRow,
}) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows.map((row: TableRow<any>, index: number) => {
    prepareRow(row);

    const isEven = alternating && index % 2 === 0;
    const isOdd = alternating && (index + 1) % 2 === 0;

    return (
      <Row
        key={row.original.id}
        row={row}
        borderBottom={borderBottom}
        borderRight={borderRight}
        tableBodyStyle={tableBodyStyle}
        fullWidth={fullWidth}
        isEven={isEven}
        isOdd={isOdd}
        onRowClick={onRowClick}
        isDeleted={isRowDeleted && isRowDeleted(row?.original)}
        hasRowReordering={hasRowReordering}
        selectedReorderingRow={selectedReorderingRow}
      />
    );
  });

export default BodyView;
